import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useDebounce from '../../hooks/useDebounce';
import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';

const SearchInput = ({
  placeholder,
  onSearchChange,
  className,
  type,
  debounce = true,
}) => {
  // Search string
  const [searchString, setSearchString] = useState();
  const setSearch = () => onSearchChange(searchString);
  const pauseAndRestart = debounce ? useDebounce(setSearch) : setSearch;
  useDidUpdateEffect(pauseAndRestart, [debounce, searchString]);

  return (
    <input
      type={type || 'text'}
      className={className}
      placeholder={placeholder || 'Search here'}
      onChange={(e) => setSearchString(e?.target?.value)}
    />
  );
};

SearchInput.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  debounce: PropTypes.bool,
};

export default SearchInput;
